import BookScreenButton from "./BookScreenButton";
import { Button, Tooltip } from "@material-ui/core";

interface ScreenProps {
  isRecording: boolean;
  isLastPage: boolean;
  hasRecordedPage: boolean;
  onDelete: (continueRecording: boolean) => void;
  onNext: () => Promise<void>;
  onSubmit: () => Promise<void>;
}

export default function ReadingPaneButtons(props: ScreenProps) {
  return (
    <div className="bottomButtons">
      {!props.isRecording && props.hasRecordedPage && (
        <BookScreenButton
          text="Try Again"
          tooltip="Delete your current recording and record it again"
          onPressed={() => {
            props.onDelete(true);
          }}
        />
      )}

      {
        // If there are more pages, show a next button
        !props.isLastPage && (
          <BookScreenButton
            tooltip={
              props.isRecording ? "Complete this page and continue reading the next page" : "Move to the next page"
            }
            text="Next"
            onPressed={async () => {
              await props.onNext();
            }}
          />
        )
      }
      {props.isLastPage && props.isRecording && (
        <Tooltip title="Finish reading this assignment">
          <Button className="button" disabled={!props.hasRecordedPage} onClick={props.onSubmit}>
            <div className="buttonText">Submit</div>
          </Button>
        </Tooltip>
      )}
    </div>
  );
}
